import { type SecurityGroupPosition, type SecurityPosition, is401kTaxationType } from './data';

export type SellButtonProps = {
  financialSecurityId: string;
  assetTicker: string;
  shouldShow401kBlocked: boolean;
};

export type SellButtonComponent = React.FC<SellButtonProps>;

export function getSellButtonProps(
  position: SecurityPosition,
  _securityGroupPosition: SecurityGroupPosition
): SellButtonProps {
  const shouldShow401kBlocked = position.securityPositionsBySubAccount.every(sp =>
    is401kTaxationType(sp.subAccount?.legalAccount?.taxationType)
  );

  return {
    financialSecurityId: position.financialSecurity.id,
    assetTicker: position.financialSecurity.symbol,
    shouldShow401kBlocked,
  };
}
